import {POWER_TOGGLE, BANK_TOGGLE, CHANGE_VOLUME, DISPLAY_BUTTON_NAME } from '../actions/types';

const initialState = {
	powerOn: false,
	bankOn: false,
	btext: '',
	volume: 0.7
};

export const SettingsReducer = (state = initialState, action) => {
	
	switch(action.type){
	
		case POWER_TOGGLE:
			return {
				...state,
				powerOn: !state.powerOn
			};

		case BANK_TOGGLE:
			return {
				...state,
				bankOn: !state.bankOn
			};

		case CHANGE_VOLUME:
			return {
				...state,
				volume: action.payload
			};

		case DISPLAY_BUTTON_NAME: 
			return {
				...state,
				btext: action.payload
			};
	
		default: 
			return state;
	}
};
